import { Styles } from "../../../../../../legacyComponents/config"

const styles = {
	table: {
		MuiTableRow: {
			styleOverrides: {
				root: {
					"&:first-of-type": {
						"& > *": {
							fontSize: "16px",
							fontWeight: "600",

							"@media(max-width: 1024px)": {
								fontSize: "14px"
							}
						}
					}
				}
			}
		},

		MuiTableCell: {
			styleOverrides: {
				root: {
					padding: "10px",
					fontSize: "14px",
					color: "#465578",
					borderBottom: "1px solid #acbee8",

					"&:first-of-type": {
						fontWeight: "600"
					},

					"@media(max-width: 1024px)": {
						fontSize: "12px"
					}
				}
			}
		}
	},
	addButton:{
			width: "120px",
			height: "50px",
			color: "#fff",
			fontWeight: "600",
			border: "1px solid",
			borderRadius: "5px",
			cursor: "pointer",
			transition: "all .2s ease",
			background: "#7fc2ff",
			borderColor: "#7fc2ff",
			textTransform: "none",
			"&:hover": {
				color: "#465578",
				background: "transparent"
			},

			"@media(max-width: 1024px)": {
				width: "90px",
				height: "37px",
				fontSize: "12px",
				borderRadius: "3px"
			},

			"@media(max-width: 767px)": {
				width: "75px",
				minHeight: "auto !important",
				height: "35px"
			}
	},
	tableActions: {
		gap: "20px",
		flexDirection: "row",
		alignItems: "center",

		"@media(max-width: 1024px)": {
			gap: "5px"
		},

		"& button": {
			width: "120px",
			height: "50px",
			color: "#fff",
			fontWeight: "600",
			border: "1px solid",
			borderRadius: "5px",
			cursor: "pointer",
			transition: "all .2s ease",

			"&:first-of-type": {
				background: "#7fc2ff",
				borderColor: "#7fc2ff"
			},

			"&:last-of-type": {
				background: "#ff6161",
				borderColor: "#ff6161"
			},

			"&:hover": {
				color: "#465578",
				background: "transparent"
			},

			"@media(max-width: 1024px)": {
				width: "90px",
				height: "37px",
				fontSize: "12px",
				borderRadius: "3px"
			},

			"@media(max-width: 767px)": {
				width: "75px",
				minHeight: "auto !important",
				height: "35px"
			}
		}
	},

	// tableActions: {
	// 	justifyContent: "center",
	// 	alignItems: "center",

	// 	"& > *": {
	// 		fontSize: "14px !important",

	// 		"@media(max-width: 1024px)": {
	// 			fontSize: "12px !important"
	// 		}
	// 	}
	// },

	tableAction(color) {
		return {
			color,
			fontSize: "14px !important",
			fontWeight: "600",
			cursor: "pointer",

			"@media(max-width: 1024px)": {
				fontSize: "12px !important"
			}
		}
	},

	checkboxContainer: {
		marginLeft: "10px",
		width: "75px",
		height: "50px"
	},

	checkbox: {
		width: "25px",
		height: "25px",
		fontSize: "unset",
		cursor: "pointer",
		outline: "unset",
		border: "1px solid #465578",
		borderRadius: "5px",
		transition: "all 0.2s ease"
	},

	checkboxLabel: {
		cursor: "pointer"
	},

	error: {
		fontSize: "12px",
		color: Styles.Color.danger
	},
	info: {
		fontSize: Styles.FontSize.t6.size,
		fontWeight: Styles.FontSize.t6.weight,
		color: Styles.Color.primary
	}
}

export default styles
